import * as components from '../components';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';

const ComponentFactory = (function () {
  const componentMap = new Map<string, MyComponentType>();

  return {
    registerComponent(component: MyComponentType) {
      const componentId = component?.definition?.id;
      if (!componentId) {
        throw new Error(`组件不存在或缺少id属性: ${component}`);
      }
      if (componentMap.get(componentId)) {
        throw new Error(`组件id重复: ${componentId}`);
      }
      componentMap.set(componentId, component);
    },
    getComponentById(name: string) {
      return componentMap.get(name);
    },
    getComponents() {
      return componentMap;
    },
  };
})();

console.log('components:', components);

// 把所有组件都注册进Factory
// eslint-disable-next-line guard-for-in
for (const key in components) {
  // @ts-ignore
  const item = components?.[key];

  if (!item?.definition) {
    console.warn('发现component下有组件未声明definition属性2: ', key, item);
    continue;
  }
  ComponentFactory.registerComponent(item);
}

export default ComponentFactory;
